import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { Swiper, SwiperSlide} from 'swiper/react';
import { Autoplay, FreeMode, EffectCreative } from 'swiper/modules';
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/dist/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);
import 'swiper/css';
import 'swiper/css/autoplay';
import "swiper/css/free-mode";
import 'swiper/css/effect-creative';
// `allMeasures` includes all the measures packaged with this library
import configureMeasurements from 'convert-units';
import allMeasures from 'convert-units';
import '../styles/layout/recipe.scss';

import furmanos_logo from '../icons/furmanos-logo.svg';
import placeholder_img from '../images/placeholder-image.png';

// Icons
// import starEmpty from '../icons/star--empty.svg';
// import starFilled from '../icons/star--filled.svg';

Modal.setAppElement('#page');
const convert = configureMeasurements(allMeasures);

const Recipe = (props) => {
  console.log(props);
  const [recipe, setRecipe] = useState(null);

  const [product_ids, setProductIDs] = useState(null);
  const [postID, setPostID] = useState(props?.postid || null);
  const [servings, setServings] = useState(null);
  //const [relatedRecipes, setRelatedRecipes] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  //Modal.setAppElement('#page'); // Replace '#root' with the ID of your root app element

  useEffect(() => {
    if(props.recipe){
      setRecipe(props.recipe);
    } 
  },[props])

  useEffect(() => {
    //fetch recipe .json using postID for root element
    const fetchRecipe = async () => {
      try {
        const response = await fetch('/wp-json/wp/v2/recipe/'+postID);
        const data = await response.json();
        setRecipe(data);
      } catch (error) {
        console.error('Error fetching recipe:', error);
      }
    };

    if(postID !== null){
      fetchRecipe();
    }
  }, [postID]);

  useEffect(() => {
    
    if(recipe !== null){
      //fetchRelatedRecipes();
      setServings((recipe.acf.serving_size) ? recipe.acf.serving_size : recipe.acf.nutritional_label.servings);
    }
  }, [recipe]);

  const openModal = () => {
    setIsModalOpen(true);
  };
  
  const closeModal = () => {
    setIsModalOpen(false);
  };
  
  const handleClick = (id) => {
    gsap.to(window, {
      duration: 0.7,
      scrollTo: 0,
      ease: 'power3.out',
      onComplete: () => {
        setPostID(id);
      }
    });
  }
  
  if (recipe == null) {
    return <div></div>;
  } 

  console.log('Recipe',recipe);

  //const animation = { duration: 5000, easing: (t) => t }
  return (
    <>
      <header className="recipe__hero">
        {(props.inCatalog) ? (<button aria-label="Close product" className="close-button" onClick={() => {props.setActiveRecipe(null)}}>Close</button>) : null }
        <img className='logo' width={174} height={114} src={myTheme.logoUrl} alt="Site Logo" />
        {(recipe.acf && recipe.acf.gallery && recipe.acf.gallery.length > 1) ? 
        (
          <Swiper 
            className="hero__background" 
            effect={'creative'}
            creativeEffect={{
              prev: {
                shadow: true,
                translate: [0, 0, -400],
              },
              next: {
                translate: ['100%', 0, 0],
              },
            }}
            modules={[EffectCreative]}
            >
            {recipe.acf.gallery.map((image, index) => (
              <SwiperSlide key={index}>
                <img src={image[0]} width={image[1]} height={image[2]}/>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <div className="hero__background">
            {(recipe.acf && recipe.acf.gallery !== "") ? (
                <img 
                  src={recipe.acf.gallery[0][0]} 
                  width={recipe.acf.gallery[0][1]} 
                  height={recipe.acf.gallery[0][2]} 
                />
            ) : (
                <img 
                  src={(recipe.featured_image_src) ? recipe.featured_image_src[0] : placeholder_img } 
                  width={(recipe.featured_image_src) ? recipe.featured_image_src[1] : null} 
                  height={(recipe.featured_image_src) ? recipe.featured_image_src[2] : null} 
                />
            )}
          </div>
        )}
        <div className="hero__left">
            <p>Recipes</p>
            <h1 dangerouslySetInnerHTML={{ __html: recipe.title.rendered }}></h1>
            <div className="bottom__wrapper">
              <RecipeRating recipe={recipe} />
              <PageButtons recipe={recipe} />
            </div>
        </div>
        <div className="hero__right">
            <div className="time__wrapper">
                <CookingTimeTable prep_time={recipe.acf.prep_time} cook_time={recipe.acf.cook_time} o_total_time={recipe.acf.total_time}/>
            </div>
        </div>
      </header>

      <div className={recipe.acf.tips ? "recipe__content" : "recipe__content recipe__content--hide-tips"}>
        <div className="content__copy" dangerouslySetInnerHTML={{ __html: recipe.content.rendered}} />
        <div 
          className={(recipe.acf.tips) ? "content__tips" : "content__tips empty"} 
          dangerouslySetInnerHTML={{ __html: `Tips: ${recipe.acf.tips}` }}
        ></div>
        <ServingsCalculator std_servings={(recipe.acf.serving_size) ? recipe.acf.serving_size : recipe.acf.nutritional_label.servings} setServings={setServings}/>
        <IngredientList product_ids={product_ids} setProductIDs={setProductIDs} std_servings={(recipe.acf.serving_size) ? recipe.acf.serving_size : recipe.acf.nutritional_label.servings} ingredients={recipe.acf.ingredients} servings={servings} />
        <RecipeProducts product_ids={product_ids} />
        <div className="instructions__wrapper" >
          <h2>Preparation:</h2>
          <div className="content__instructions" dangerouslySetInnerHTML={{ __html: styleInstructions(recipe.acf.instructions)}}></div>
        </div>
      </div>

      <footer className="recipe__footer">
        <div className="footer__form">
          <h3>Let us know what you think!</h3>
          <button className="white-button" onClick={openModal}>Leave A Review</button>
          <Modal 
            isOpen={isModalOpen} 
            onRequestClose={closeModal}
            style={
                {
                  content: {
                  inset:'0 1em',
                  margin:'auto',
                  height:'fit-content',
                  zIndex: 1
                },
              }
            }

          >
            <ReviewForm recipe={recipe}/>
          </Modal>
        </div>
        <div className="footer__title">
          <h2 dangerouslySetInnerHTML={{ __html : recipe.related_recipes_title}}></h2>
        </div>
        <Swiper
          modules={[Autoplay, FreeMode]}
          className='figure-mouseover'
          slidesPerView={1}
          loop={false}
          freeMode={true}
          breakpoints={{
            500: {
              slidesPerView: recipe.related_recipes.length > 3 ? 3 : recipe.related_recipes.length,
            },
          }}
        >
          {recipe.related_recipes.map((rel_recipe, index) => {
              return (
                <SwiperSlide key={index} onClick={() => handleClick(rel_recipe.ID)}>
                  <figure>
                    <img src={rel_recipe.featured_image_url} width={rel_recipe.width} height={rel_recipe.height}/>
                    <figcaption dangerouslySetInnerHTML={{ __html: rel_recipe.post_title}}></figcaption>
                  </figure>
                </SwiperSlide>
              )
            })}
        </Swiper>
      </footer>
    </>
  );
};

const RecipeRating = ({ recipe }) => {
  const rating = recipe?.acf?.rating || 0; // Make sure rating is defined
  const fullStars = Math.floor(rating);
  const fraction = rating - fullStars; // e.g., 0.5 for a 4.5 rating

  const totalStars = 5;

  return (
    <div className="reviews">
      {Array.from({ length: totalStars }).map((_, i) => {
        let fillPercent = 0; // default to empty star
        if (i < fullStars) {
          fillPercent = 100; // full star
        } else if (i === fullStars && fraction > 0) {
          fillPercent = fraction * 100; // partial star
        }

        const gradientId = `starGradient${i}_${recipe.id}`;
        
        return (
          <svg
            key={i}
            xmlns="http://www.w3.org/2000/svg"
            width="39.179"
            height="37.261"
            viewBox="0 0 39.179 37.261"
            style={{ marginRight: '2px' }}
          >
            <defs>
              <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" style={{'stop-color': "var(--fill)"}} />
                <stop offset={`${fillPercent}%`} style={{'stop-color': "var(--fill)"}} />
                <stop offset={`${fillPercent}%`} style={{'stop-color': "var(--empty)"}} />
                <stop offset="100%" style={{'stop-color': "var(--empty)"}} />
              </linearGradient>
            </defs>
            <path
              d="M19.589,0,13.535,12.266,0,14.233l9.8,9.547L7.482,37.261,19.589,30.9,31.7,37.261,29.384,23.78l9.795-9.547L25.642,12.266Z"
              fill={`url(#${gradientId})`}
              style={{'stroke': 'var(--fill)', 'stroke-width': '2px'}}
            />
          </svg>
        );
      })}

      {/* If you have a review count in recipe.acf.review_count */}
      <span>({recipe?.acf?.number_of_reviews || 0} reviews)</span>
    </div>
  );
}

const RecipeProducts = ({product_ids}) => {
  const [products, setProducts] = useState(null);

  useEffect(() => {
    const fetchProduct = async (postID) => {
      try {
        const response = await fetch('/wp-json/wp/v2/product/'+postID);
        const data = await response.json();
        return data;
      } catch (error) {
        console.error('Error fetching recipe:', error);
      }
    };

    // let products = ingredients
    //   .filter(item => item.acf_fc_layout === 'product' && item.product !== '')
    //   .map(item => fetchProduct(item.product));
    if(product_ids){
      const product_data = product_ids.map(item => fetchProduct(item));
      Promise.all(product_data)
        .then(async resolvedProducts => {
          setProducts(resolvedProducts);
        })
        .catch(error => {
          console.error(error);
        });
    }

  }, [product_ids]);

  if(!products || products[0]?.length == 0){
    return <div>No products</div>;
  }

  return (
    <div className="product-list__wrapper">
      <h2>In this recipe:</h2>
      <div className="product-list">
        {products.map((product, index) => (
          <a aria-label="Open product page" key={index} className="product_figure" href={product.link} target='_self'>
            <img src={ (product.featured_image_src_large[0] !== undefined) ? product.featured_image_src_large[0] : ''} />
            <div dangerouslySetInnerHTML={{__html:product.title.rendered}}></div>
          </a>
        ))}
      </div>
    </div>
  );
}

const CookingTimeTable = ({ prep_time, cook_time, o_total_time}) => {
  //takes minutes recipes time and converts to XH XMs.
  let total_time = prep_time + cook_time;
  let times = [prep_time, cook_time, total_time];
  let format_times = times.map(function(time){
      if (time == 0){
        return `N/A`;
      }
      let hours = Math.floor(time / 60);
      let minutes = time % 60;
      return (hours + minutes == 0) ? `N/A` : `${hours}H ${minutes}M`.replace(/\b0./g, "");
  });
  return (
      <table>
          <tbody>
              <tr>
                <td>{format_times.shift()}</td>
                <td>{format_times.shift()}</td>
                <td dangerouslySetInnerHTML={{ __html: (o_total_time != '') ?  o_total_time.replace('\r\n','<br>') : format_times.shift()}}></td>
              </tr>
              <tr>
                <td>Prep Time</td>
                <td>Cook Time</td>
                <td>Total Time</td>
              </tr>
          </tbody>
      </table>
  )
}

const IngredientList = ({product_ids,setProductIDs, std_servings, ingredients, servings}) => {
  // console.log('IngredientList');
  // console.log('std_servings',std_servings);
  // console.log('ingredients',ingredients);
  // console.log('servings',servings);
  //servings => user specificed serving size
  //ingredients => ingredients (amount, units, type, etc) that are portioned to the std_servings
  //std_servings => default serving size
  //
  //headers are sub-lists within ingredients
  const [list,setList] = useState(null);
  const [header,setHeader] = useState(null);

  
  useEffect(() => {
    let temp = [];
    let temp_header = [];
    let temp_prod_ids = [];
    //Creates ratio of default/user servings size
    let ratio = (Number(std_servings) / Number(servings));
    // console.log('ratio',ratio);
    ratio = (ratio > std_servings) ? ratio : ratio**-1;
    //Update ingredient amount & unit based on ratio
    ingredients.forEach((item, index) => {
      if(item.acf_fc_layout == 'header'){
        temp.push(item.text);
        temp_header.push(index);
      } else{
        let unit = item.unit;
        let quantity = Number(item.quantity);
        quantity *= ratio;
        // console.log('ratio',ratio);
        [quantity, unit] = (quantity == Infinity || quantity < 0.1) 
          ? [(item.prepend_as_needed) ? 'As needed' : '', ''] 
          : makeQuantityPretty(quantity,unit);
        //Amount less than 0.1? say 'As needed'
        // console.log('item',item);
        // console.log(quantity, unit);
        switch (item.acf_fc_layout) {
          case 'ingredient':
            // console.log('case ingredient');
            temp.push([makeFraction(quantity),makeUnitPretty(quantity,unit),item.ingredient].join(' '));
            break;
          case 'product':
            console.log('case product');
            console.log('item',item);
            console.log(quantity, unit);
            if(item.product !== '' && item.name !== '' && item.variant.product !== null){ 
              let html = checkVariant(item,quantity,unit,item.variant,ratio);
              // html = html.replace(/furmano/gi, '<b>$&') || `<b>${html}`;
              //this is a mess I know, not proud of this
              //extra prodId to update ProductList component
              const startIndex = html.indexOf('href=/?p=') + 'href=/?p='.length;
              const endIndex = html.indexOf('>', startIndex);
              const prod_id = html.substring(startIndex, endIndex);
              if(prod_id){
                temp_prod_ids.push(prod_id);
              }
              temp.push(html);
            } else if(item.product !== '' && item.name !== ''){ 
              // console.log('q', quantity, 'unit', unit, 'makePretty', makeUnitPretty(quantity,unit));
              let html = `<a href="/?p=${item.product}">`+[makeFraction(quantity),makeUnitPretty(quantity,unit),'<b>',item.name].join(' ')+`</b></a>`;
              // html = html.replace(/furmano/gi, '<b>$&') || `<b>${html}`;
              temp_prod_ids.push(item.product);
              temp.push(html);
            } else if(item.product == '' && item.name !== ''){ 
              temp.push([makeFraction(quantity),makeUnitPretty(quantity,unit),item.name].join(' '));
            } else {      
              temp.push([makeFraction(quantity),makeUnitPretty(quantity,unit)].join(' '));
            }
            break;
          default:
            break;
        }
      }
    });
    setList(temp);
    setHeader(temp_header);
    if(product_ids !== temp_prod_ids){
      setProductIDs(temp_prod_ids);
    }
    return () => {
      // Clean-up logic, none needed
    };
  }, [servings]);

  if(!list){
    return <div>Loading...</div>;
  }


  return (
    <div className="ingredients__wrapper">
      <h2>Ingredients</h2>
      <span>Serves {servings}</span>
      <ul className="content__ingredients">
        {list.map((item, index) => (
          <li className={header.includes(index) ? 'header' : 'item'} key={index} dangerouslySetInnerHTML={{ __html:item}}></li> 
        ))}
      </ul>
    </div>
  );  
}

const ServingsCalculator = ({ setServings, std_servings}) => {
  //Allow user to specify custom servings amount
  const [inputValue, setInputValue] = useState(std_servings);

  const inputChange = (event) => {
    const newValue = Number(event.target.value);
    setInputValue(newValue);
    setServings(newValue);
  }

  return(
    <div className="servings-calculator">
      <div className="top">
        <img src={furmanos_logo} alt="furmanos logo" />
        <h3>Recipe Calculator</h3>
      </div>
      <div className="bottom">
        <label>Servings Size: <input type='number' min='1' max='100' value={inputValue} onChange={inputChange}/></label>
      </div>
    </div>
  )
}

const PageButtons = ({recipe}) => {
  const handlePrint = () => {
    window.print();
  }

  const handleShare = async () => {
    try {
      await navigator.share({
        title: recipe.title,
        text: 'Check out this recipe!',
        url: recipe.link.replace('http://','https://'),
      });
    } catch (error) {
      //navigator.clipboard.writeText(recipe.link.replace('http://','https://'));
      // alert('Web Share API is not supported in this browser or context. Recipe link was copied to clipboard instead');
      alert('Web Share API is not supported in this browser or context.');
      console.error('Error sharing:', error);
    }
  };
  // const handleDownload = () => {
  //   window.print();
  // }

  return (
    <div className="buttons">
      {/* <button onClick={() => handleDownload()}>Download</button> */}
      <button className="print-button" onClick={() => handlePrint()}>Print</button>
      <button className="share-button" onClick={handleShare}>Share</button>
    </div>
  )
}

const ReviewForm = ({recipe}) => {
  const [rating, setRating] = useState(0);

  const starCount = 5;

  const handleStarClick = (value) => {
    setRating(value);
  };

  return (
    <form method="post" action="">
      <input type="hidden" name="recipe_id" value={recipe.id} />

      <label for="review-rating">Your Name:</label>
      <input type="string" id="review-name" name="review_name" />

      <label for="review-rating">Your Rating (0-5):</label>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {Array.from({ length: starCount }, (_, i) => {
          const starValue = i + 1;
          const isFilled = starValue <= rating;
          const gradientId = `gradient_${i}`;
          const fillPercent = isFilled ? 100 : 0; 
          const fillColor = isFilled ? 'gold' : '#ccc';
          const strokeColor = isFilled ? 'gold' : '#ccc';

          return (
            <svg
              key={i}
              onClick={() => handleStarClick(starValue)}
              xmlns="http://www.w3.org/2000/svg"
              width="39.179"
              height="37.261"
              viewBox="0 0 39.179 37.261"
              style={{ marginRight: '2px', cursor: 'pointer' }}
            >
              <defs>
                <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor={fillColor} />
                  <stop offset={`${fillPercent}%`} stopColor={fillColor} />
                  <stop offset={`${fillPercent}%`} stopColor="#ccc" />
                  <stop offset="100%" stopColor="#ccc" />
                </linearGradient>
              </defs>
              <path
                d="M19.589,0,13.535,12.266,0,14.233l9.8,9.547L7.482,37.261,19.589,30.9,31.7,37.261,29.384,23.78l9.795-9.547L25.642,12.266Z"
                fill={`url(#${gradientId})`}
                style={{ stroke: strokeColor, strokeWidth: '2px' }}
              />
            </svg>
          );
        })}
        <input type="hidden" name="review_rating" value={rating} />
      </div>

      <label for="review-comment">Your Review:</label>
      <textarea id="review-comment" name="review_comment" required></textarea>

      <label for="submit_review">By submitting this review, I acknowledge I have read and consented to the <a href='/privacy-policy'>terms</a> of this website.</label>
      <input class='button' type="submit" name="submit_review" value="Submit Review" />
    </form>
  )
}

//functions

function makeQuantityPretty(quantity, unit){
  //convert ingredients to their best unit
  // console.log('makeQuantityPretty',quantity, unit);
  const exclusion = ['ft3', 'in3', 'yd3', 'pnt', 'qt', 'gal'];
  const exclusion_floz = [...exclusion, 'fl-oz'] ;
  let conv_unit = Object;
  let unit_s = '';
  let unit_val = 0;
  quantity = Number(quantity); 
  //console.log('og unit',unit);
  // if(ratio !== 1){
  //   //Attempt unit convertion
    try{
      switch(unit){
        // case 'pt' :
        //   conv_unit = convert.val(quantity).from('pnt').toBest({ exclude : exclusion_floz});
        //   break;
        case 'fl.oz':
          conv_unit = convert.val(quantity).from('fl-oz').toBest({ exclude : exclusion});
          break;
        case 'tbsp' :
          conv_unit = convert.val(quantity).from('Tbs').toBest({ exclude : exclusion_floz, cutOffNumber: 0.5});
          break;
        case 'cup' :
          conv_unit = convert.val(quantity).from('cup').toBest({ exclude : exclusion_floz, cutOffNumber: 0.25});
          break;
        case 'tsp' :
          conv_unit = convert.val(quantity).from('tsp').toBest({ exclude : exclusion_floz, cutOffNumber: 4});
          break;
        case '--' :
          return [quantity, ''];
        default: 
          conv_unit = convert.val(quantity).from(unit).toBest({ exclude : exclusion_floz});
          break;
        }
    } catch(err) {
      console.log(err);
      return ['!'+quantity, unit]
    }
  // } else {
  //   conv_unit = convert.val(quantity).from(unit);
  // }
  unit_s = conv_unit.unit.toLowerCase();
  unit_val = conv_unit.val;

  return [unit_val, unit_s];
}

function makeUnitPretty(quant = null,unit_s){
  if(quant == null || unit_s == ''){
    return unit_s;
  }
  //console.log(unit_s);
  unit_s = (quant > 1) ? unit_s + 's' : unit_s;
  if(unit_s === 'lb' || unit_s === 'lbs') {
    return unit_s + '.';
  }
  if(unit_s === 'tbs' || unit_s === 'tbss') {
    return 'tbsp';
  }
  if(unit_s == 'ozs'){
    return 'oz';
  }
  if(unit_s == 'tsps'){
    return 'tsp';
  }
  return unit_s;
}

function makeFraction(unit_val) {
  // console.log('makeFraction',unit_val)
  if (typeof unit_val !== 'number' || isNaN(unit_val)) {
    // console.log('Invalid input; must be a number.');
    return unit_val;
  }

  const decimal = unit_val % 1;

  if (decimal === 0) {
    return unit_val;
  }

  const denominatorOptions = [2, 3, 4, 6, 8];
  let closestFraction = null;
  let closestDifference = Infinity;

  for (const denominator of denominatorOptions) {
    const numerator = Math.round(decimal * denominator);
    const difference = Math.abs(decimal - numerator / denominator);
    // console.log('num', numerator, 'dom', denominator, 'diff', difference);
    // console.log('closestDifference',closestDifference)
    if (difference < closestDifference) {
      const fractionValue = numerator / denominator;
      if (fractionValue === 0 || fractionValue === 1) {
        continue;
      }
      closestFraction = `<span class='numerator'>${numerator}</span><span class='divider'>/</span><span class='denominator'>${denominator}</span>`;
      closestDifference = difference;
      // console.log("new closestDifference!",closestDifference);
    }
  }
  // console.log('closestFraction',closestFraction);

  // console.log('closetFraction', closestFraction);
  let first_num = (Math.floor(unit_val) !== 0) ? Math.floor(unit_val) : '';
  // console.log('eval', closestFraction == true, Math.round(unit_val));
  return closestFraction ? `${first_num} ${closestFraction}` : Math.round(unit_val);
}


// function round(number) {
//   //throw away rounding function
//   if (Number.isInteger(number)) {
//     return number; // No decimal part, return the integer as is
//   } else {
//     return Number(number.toFixed(1)); // Round to 1 significant figure
//   }
// }

function styleInstructions(html) {
  const tempElement = document.createElement('div');
  tempElement.innerHTML = html;

  const olElements = tempElement.querySelectorAll('ol');

  olElements.forEach((olElement) => {
    const liElements = olElement.querySelectorAll('li');

    liElements.forEach((liElement) => {
      const spanElement = document.createElement('span');

      spanElement.innerHTML = liElement.innerHTML;
      spanElement.classList.add('shift');

      liElement.innerHTML = '';

      liElement.appendChild(spanElement);

      const hrElement = document.createElement('hr');

      olElement.insertBefore(hrElement, liElement.nextSibling);
    });
  });

  // Return the modified HTML
  return tempElement.innerHTML;
}

const checkVariant = (item, i_quantity, i_unit, v_data, ratio) =>{
  //quantity,unit already converted to ratio
  console.log("Check variant", v_data);
  if(ratio == Infinity || ratio == 1){
    return `<a href=/?p=${item.product}>`+[i_quantity,makeUnitPretty(i_quantity,i_unit),'<b>',item.name].join(' ')+`</b></a>`;
  }
  let v_quantity;
  if(v_data.unit !== '--' && v_data.unit != i_unit){
    //convert units
    // console.log(v_data.quantity,v_data.unit,i_unit);
    // console.log('v_data.quantity',v_data.quantity,v_data.unit,'i_quantity ',i_quantity, i_unit );
    v_quantity = convert.val(v_data.quantity).from(v_data.unit).to(i_unit) * ratio;
    console.log('converted to',v_quantity,i_unit);
  } else {
    v_quantity = v_data.quantity;
  }

  let comparison;
  if(v_data.sign == 'greater'){
    console.log('greater',v_quantity,i_quantity);
    comparison = (i_quantity > v_quantity);

  } else if (v_data.sign == 'less'){
    // console.log('less than');
    comparison = (i_quantity < v_quantity);
  } 
  
  
  if (comparison){
    console.log('true! use variant');
    const [quantity, unit] = makeQuantityPretty(i_quantity, v_data.unit);
    console.log(v_data.quantity, v_data.unit, ratio, '=>', quantity, unit);
    //true, use variant
    return `<a href=/?p=${v_data.product}>`+[makeFraction(quantity),makeUnitPretty(quantity,unit),'<b>',v_data.name].join(' ')+`</b></a>`;
  }else {
    // keep the same
    console.log('false; dont use variant');
    return `<a href=/?p=${item.product}>`+[makeFraction(i_quantity),makeUnitPretty(i_quantity,i_unit),'<b>',item.name].join(' ')+`</b></a>`;
  }

}


export default Recipe;